import React, { useState } from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import { Leaderboard, League } from "../../../../types/model";
import { useAppSelector } from "../../../../store/hooks";
import { RootState } from "../../../../store/store";
import { IoGlobeSharp } from "react-icons/io5";
import { FaFlagCheckered } from "react-icons/fa6";
import { getLeaderboard } from "../../../../services/leaderboardService";

interface ViewLeagueCardProps {
	league: League;
	currentPosition?: number;
	showSport?: boolean;
	showSeries?: boolean;
	onViewLeague: (leagueId: string) => void;
}

const ViewLeagueCard: React.FC<ViewLeagueCardProps> = ({
	league,
	currentPosition = 0,
	showSport = false,
	showSeries = false,
	onViewLeague,
}) => {
	const { sports, series } = useAppSelector(
		(state: RootState) => state.fantasy,
	);

	const leagueSport = sports.find((sport) => sport._id === league.sport);
	const leagueSeries = series.find((series) => series._id === league.series);

	return (
		<Card className="bg-dark text-white mb-1 border-1 border-info">
			<Card.Body>
				<Row className="align-items-center">
					<Col
						className="d-flex align-items-center flex-row"
						style={{ overflow: "hidden", wordWrap: "break-word" }}
					>
						{league.featured ? (
							<IoGlobeSharp className="me-2" size={20} />
						) : (
							<FaFlagCheckered className="me-2" size={20} />
						)}
						<div
							className="fs-6 fw-bold text-nowrap"
							style={{ overflow: "hidden", textOverflow: "ellipsis" }}
							title={league.name}
						>
							{league.name.toLocaleUpperCase()}
						</div>
						{currentPosition > 0 && (
							<Button
								className="rounded-pill ms-1 py-0 px-1 border-0 fw-bold fs-6"
								variant="outline-success"
							>
								#{currentPosition}
							</Button>
						)}
					</Col>
					{showSport && (
						<Col className="fw-bold text-white">
							<span>{leagueSport?.name.toLocaleUpperCase() ?? ""}</span>
						</Col>
					)}
					{showSeries && (
						<Col className="text-md-end text-center fw-light text-info">
							<span>{leagueSeries?.name.toLocaleUpperCase() ?? ""}</span>
						</Col>
					)}
					<Col
						className="text-end p-0"
						style={{ flex: "0 0 auto", width: "auto" }}
					>
						<Button
							variant="primary"
							size="sm"
							className="fw-bold me-2"
							style={{ width: "fit-content" }}
							onClick={() => onViewLeague(league._id || "")}
						>
							VIEW LEAGUE
						</Button>
					</Col>
				</Row>
			</Card.Body>
		</Card>
	);
};

export default ViewLeagueCard;
